import { Message, RiskStatus } from "@/app/store/types";
import { parseFileData } from "@/app/utils/file";
import { Image } from "@douyinfe/semi-ui";
import React, { useMemo } from "react";
import styles from "./Image.module.scss";
import { useFileLoaded } from "@/app/hooks/useFileLoad";
import Locale from "@/app/locales";

function ImageComponent({ msg }: { msg: Message }) {
  const { onload } = useFileLoaded(msg);
  const content = msg.content as string;

  const { fileUrl, fileName } = useMemo(() => {
    const parsed = parseFileData(content);
    return {
      fileUrl: parsed?.fileUrl,
      fileName: parsed?.fileName ?? "",
    };
  }, [content]);

  if (msg.riskStatus === RiskStatus.Failed) {
    return <div>{Locale.riskMsg.forbidden}</div>;
  }

  return (
    <Image
      src={fileUrl}
      alt={fileName}
      height={200}
      className={styles.image}
      onLoad={onload}
    />
  );
}

/** 列表重绘时若消息实质未变，跳过重渲染，减轻图片组件重复工作 */
export default React.memo(
  ImageComponent,
  (prev, next) =>
    prev.msg.content === next.msg.content &&
    prev.msg.riskStatus === next.msg.riskStatus &&
    prev.msg.isNewMsg === next.msg.isNewMsg,
);
